import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  customers : [],
  loading : false,
  outDated : true,
  firstCorporateCustomer : null,
  page : 1,
  pages : 1, //nombre de page total
  per_page : 20,
  mode : 'tile',
  count : 0,
  search : '',
  overdue : 0.00,
  outstanding:0.00,
  draft : 0.00,
  orderBy:{orderName : 'createdAt',  direction:'DESC'},
  sort_icon : 'el-icon-caret-bottom',
  icons : {
    'DESC' : 'el-icon-caret-bottom',
    'ASC' : 'el-icon-caret-top'
  },
  filters : {
    active : true,
    customerTypes : [{id:0, code:'Client particulier'},{id:1, code:'Client corporatif'}],
    checkedCustomerTypes : [],
    customerTypesOutDated : true,
    customerClasses: null,
    customerClassesOutDated : true,
    checkedCustomerClasses : [],
    tags : null,
    checkedTags : [],
    tagsOutDated : true,
    checkedReps : [],
    checkedTerritories : [],
    withoutReps : false,
    withoutTerritories : false,
    checkedPortausCompanies: [],
  }

});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
